module.exports = __webpack_public_path__ + "static/img/foot_img.1bd1739.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/foot_img.png
// module id = hn+C
// module chunks = 17